import styled from 'styled-components'
import { colors } from 'client/styles'

export const FeedbackVoucherBase = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: ${colors.white};
  border: 2px solid;
  border-radius: 8px;
  color: ${props => (props.status === 'STATUS_OK' ? `${colors.orange}` : `${colors.red2}`)};
  border-color: ${props => (props.status === 'STATUS_OK' ? `${colors.orange}` : `${colors.red2}`)};
  width: 100%;
  padding-block: 10px;
  padding-inline: 20px;

  svg {
    fill: ${props => (props.status === 'STATUS_OK' ? `${colors.orange}` : `${colors.red2}`)};
  }
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  padding-block-end: 10px;
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline-end: 8px;
`

export const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
